var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNextArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.443,
    height: 69.1,
    viewBox: "0 0 30.443 69.1",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_231",
    "data-name": "Trazado 231",
    d: "M-19907.334,581.333l21.25,30.167-21.25,29.167",
    transform: "translate(19912.223 -576.456)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 7
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNextArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nextArrow.d8c271e23f158dd154fb098433b64866.svg";